import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import OfftakerCounterpartyPanDetailsPageUI from './OfftakerCounterpartyPanDetailsPageUI'

class OfftakerCounterpartyPanDetailsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      errorList: [],
      pan: null,
      company: null,
      loan: null,
    }
  }

  render() {
    return (
      <OfftakerCounterpartyPanDetailsPageUI
        context={this.props.context}
        loading={this.state.loading}
        errorList={this.state.errorList}
        pan={this.state.pan}
        company={this.state.company}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    this.getPanDetails()
    this.getLoan()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.pan !== this.props.match.params.pan) {
      this.getPanDetails()
    }
    if (prevProps.match.params.loanId !== this.props.match.params.loanId) {
      this.getLoan()
    }
  }

  onRefreshClick = () => {
    this.getPanDetails()
  }

  getPanDetails() {
    const pan = (this.props.match.params.pan || '').trim()
    if (!pan) {
      this.setState({ loading: false, errorList: ['PAN not provided'] })
      return
    }
    this.setState({ loading: true, errorList: [], pan: pan })

    RestApiUtils.get(
      this.props.context,
      '/api/su/externalDataCache/type/PAN_TO_COMPANY_DETAILS',
      this.onLoadCallback,
      null,
      { key: pan }
    )
  }

  onLoadCallback = (response) => {
    const errorList = []
    if (response && response.errorList && response.errorList.length > 0) {
      response.errorList.forEach(e => errorList.push(e.message || String(e)))
    }

    let company = null
    try {
      const valueStr = response && response.externalDataCache && response.externalDataCache.value
      if (valueStr) {
        const parsed = JSON.parse(valueStr)
        if (parsed && Array.isArray(parsed.msg) && parsed.msg.length > 0) {
          company = parsed.msg[0]
        }
      }
    } catch (e) {
      errorList.push('Failed to parse PAN details')
    }

    this.setState({
      loading: false,
      errorList: errorList,
      company: company,
    })
  }

  getLoan() {
    const loanId = this.props.match.params.loanId
    if (!loanId) return
    const cacheManager = new CacheManager({
      resource: `/api/su/loans/${loanId}`,
      cacheKey: CacheKeys.Loan(loanId),
      callback: (resp) => this.setState({ loan: resp.loan }) ,
      ttlInSecs: 600
    })
    cacheManager.getObject2(this.props.context)
  }
}

export default withRouter(OfftakerCounterpartyPanDetailsPageSF)


